/* eslint-disable */
// eslint-disable-next-line

import { getProjectWinflowsFileList } from "../shared/api/url-helper";
import { decrypt_data } from "../shared/utils";

// Stream Overlay
// export let streamDataProp = ['streamName', 'source', 'destination', 'flow', 'press', 'tds', 'ph', 'malk', 'hardness', 'density', 'osmotic_pressure', 'conductivity'];
// export const DefaultsSreamDataProp = ['streamName', 'source', 'destination', 'flow', 'press', 'tds', 'ph', 'malk', 'hardness', 'density', 'osmotic_pressure', 'conductivity'];
export let checkUnitType = ['RO_HP', 'RO', 'RO_ERD', 'RO_PW', 'RO_TC', 'CLRO', 'ROHP_FeedBleed', 'RO_FeedBleed'];
export let streamDataProp = ['streamName', 'flow', 'press', 'tds', 'ph', 'malk', 'hardness', 'density', 'osmotic_pressure', 'conductivity'];
export const DefaultsSreamDataProp = ['streamName', 'flow', 'press', 'tds', 'ph', 'malk', 'hardness', 'density', 'osmotic_pressure', 'conductivity'];

export const setStreamDataProp = (ar = DefaultsSreamDataProp) => {
  streamDataProp = ar;
};

export const getStreamDataProp = () => {
  return streamDataProp;
};

// My & Shared project file ----------------------------------

let sharedFileOnly = {};
export const getSharedFileOnly = () => {
  return sharedFileOnly;
};
export const setSharedFileOnly = (data) => {
  sharedFileOnly = data;
};

export let myAndSharedFile = {};

export const setMyAndSharedFile = (data) => {
  myAndSharedFile = data;
  if (Object.keys(getSharedFileOnly()).length === 0) {
    setSharedFileOnly(data);
  }
};

export const getMyAndSharedFile = () => {
  return myAndSharedFile;
};

// for ab value factor-----------------------------------------
export let abValFactCheckedDict = {};

export const addInABFobj = (key, val) => { // to add the id of all ro unitops and value (true/false)
  abValFactCheckedDict[key] = val;
};

export const updateOneKeyInABFObj = (key, val) => { // to update the id of all ro unitops and value (true/false)
  abValFactCheckedDict[key] = val;
};


// if true then show default value based on abValue factor 
// if false then show the user defined data
export const updateAllKeyInABFObj = () => { // when ab value radio button toggled -> change all ro unitsops value to true,
  // so that defalut ab value will display in the all forms
  const allKey = Object.keys(abValFactCheckedDict);
  const obj = {};
  for (let i = 0; i < allKey.length; i++) {
    obj[allKey[i]] = true;
  }
  abValFactCheckedDict = { ...obj };
  return abValFactCheckedDict;
}

// to get the entire from ab value checked
export const getAbValFactCheckedDict = () => {
  return abValFactCheckedDict;
};

// reset ab value factor to empty obj.
export const resetAbValFactCheckedDict = () => {
  abValFactCheckedDict = {};
}


// home btn click flag
export let homeBtnClkFlag = false;

export const setHomeBtnClkFlag = (val) => {
  homeBtnClkFlag = val;
};

export const getHomeBtnClkFlag = () => {
  return homeBtnClkFlag;
};


// ###### CLRO Access users #####

let isClroAccess = false;

export const check_CLRO_access = (userData, str = 'CLRO User') => {
  let userDataObj = {};
  for (let key in userData) {
    let trimmedKey = key.trim(); // Remove leading/trailing spaces from the key
    userDataObj[trimmedKey] = userData[key];
  }
  const currUserEmail = sessionStorage.getItem('user_email');
  const AccountType = userDataObj[currUserEmail]?.AccountType || '';
  if (AccountType) { }
  const allowedRoles = ['WF5 Administrator', 'MemChem CoE', str];
  const hasAllowedRole = allowedRoles.some(role => AccountType.includes(role));
  if (hasAllowedRole) {
    return true;
  }
  return false;
}

// GB-2659 -start
// In RO form, if the users don't have access to any element model under a given element group,
// then that element group should be hidden. Eg: NF PA--> Seawater NF
//my unique element model
export let myUniqElementModels_ud = false;

export const setmyUniqElementModels_ud = (val) => {
  myUniqElementModels_ud = val;
};

export const getmyUniqElementModels_ud = () => {
  return myUniqElementModels_ud;
};
// GB-2659 End

export let projectInfoOpenFlag = false;

export const setProjectInfoOpenFlag = (val) => {
  projectInfoOpenFlag = val;
};

export const getProjectInfoOpenFlag = () => {
  return projectInfoOpenFlag;
};

export let unSavedprojectInfoOpenFlag = false;

export const unSavedsetProjectInfoOpenFlag = (val) => {
  unSavedprojectInfoOpenFlag = val;
};

export const unSavedgetProjectInfoOpenFlag = () => {
  return unSavedprojectInfoOpenFlag;
};
let saveFlowSheetFlag = false; // default set false after press save button true when jump to my project tab set false
export const setAfterSavingClick = (val) => {
  saveFlowSheetFlag = val;
}
export const getAfterSavingClick = () => {
  return saveFlowSheetFlag;
};

// export const readPreconfigFilesFromS3_temp = {
//     'Single Pass': 
//                 ['preconfig/Single Pass/Brine Staged RO.json', 'preconfig/Single Pass/Single Pass NF (Seawater feed).json', 'preconfig/Single Pass/Single Pass RO (Brackish water feed).json', 'preconfig/Single Pass/Single Pass RO (Seawater feed).json', 'preconfig/Single Pass/Single Pass RO + Isobaric ERD (PX).json', 'preconfig/Single Pass/Single Pass RO + Isobaric ERD (WX).json', 'preconfig/Single Pass/Single Pass RO + Pelton Wheel ERD.json', 'preconfig/Single Pass/Single Pass RO + Turbocharger ERD.json', 'preconfig/Single Pass/Single Pass RO with Concentrate Recycle.json', 'preconfig/Single Pass/Single Pass RO with Permeate Recycle.json', 'preconfig/Single Pass/Single Pass RO with Pre-RO Acid Dosing.json'], 
//     'Multi-Pass': 
//                 ['preconfig/Multi-Pass/Double Pass RO (Brackish water feed).json', 'preconfig/Multi-Pass/Double Pass RO (Seawater feed).json', 'preconfig/Multi-Pass/Double Pass RO + Isobaric ERD (PX).json', 'preconfig/Multi-Pass/Double Pass RO with Concentrate Recycle + Isobairc ERD (PX).json', 'preconfig/Multi-Pass/Double Pass RO with Two Concentrate Recycle Loops.json', 'preconfig/Multi-Pass/Partial Double Pass RO with Concentrate Recycle + Isobairc ERD (PX).json', 'preconfig/Multi-Pass/Partial Double Pass RO with Concentrate Recycle.json', 'preconfig/Multi-Pass/Split Partial Double Pass RO with Concentrate Recycle + Isobairc ERD (PX).json', 'preconfig/Multi-Pass/Split Partial Double Pass RO with Concentrate Recycle.json', 'preconfig/Multi-Pass/Triple Pass RO with Concentrate Recycle to Pass 1 Feed.json', 'preconfig/Multi-Pass/Triple Pass RO with Concentrate Recycle to Pass 2 Feed.json'],
//     'EDI Flowsheets': 
//                 ['preconfig/EDI Flowsheet/Double Pass RO → EDI.json', 'preconfig/EDI Flowsheet/Na-Cycle Softener → Single Pass RO → CO2 Gas Stripper → EDI.json', 'preconfig/EDI Flowsheet/Single Pass RO (Brackish water feed) → EDI.json', 'preconfig/EDI Flowsheet/Standalone EDI.json', 'preconfig/EDI Flowsheet/Triple Pass RO with Concentrate Recycle to Pass 2 Feed → EDI.json'],
//     'Argo Analyzer': 
//                 ['preconfig/Argo Analyzer/Argo_template.json', 'preconfig/Argo Analyzer/Argo_template_Feed_dosing.json', 'preconfig/Argo Analyzer/Argo_template_Product_dosing.json', 'preconfig/Argo Analyzer/Argo_template_SWRO_1pass.json', 'preconfig/Argo Analyzer/Argo_template_SWRO_2pass.json'],
//     'Tutorial': 
//                 ['preconfig/Tutorial/Acid Dosing → H2S Gas Stripper → Caustic Dosing → Single Pass RO.json', 'preconfig/Tutorial/Acid Dosing → Two Pass RO with Interpass CO2 Gas Stripper.json', 'preconfig/Tutorial/Double Pass NF-RO (Seawater feed).json', 'preconfig/Tutorial/Double Pass RO + Interpass Acid Dosing.json', 'preconfig/Tutorial/Single Pass RO → Ammonia Gas Stripper.json']
// };

export let preconfigFiles = '';

export const setPreconfigFiles = (val) => {
  preconfigFiles = val;
};

export const getPreconfigFiles = () => {
  return preconfigFiles;
};


export let userDictData = '';

export const setUserDictData = (val) => {
  userDictData = val;
};

export const getUserDictData = () => {
  return userDictData;
};

export const getSharedProjectsList = async (getUserEmail, getUserType, page = 1, limit = 0, type = 'shared_projects') => {
  let data = await getProjectWinflowsFileList(getUserEmail, getUserType, page, limit, type);
  if (type === 'shared_file_count') {
    const arr = [];
    for (let i = 0; i < data.data.unread_counter; i += 1) {
      arr.push(i);
    }
    return arr;
  }
  return data;
};
export const getMyProjectsList = async (getUserEmail, getUserType, page = 1, limit = 0, type = 'my_projects', path = '') => {
  const data = await getProjectWinflowsFileList(getUserEmail, getUserType, page, limit, type, path);
  return data;
};

export const decryptDataSharedAndMyProject = (response) => {
  const resFiles = Object.values(response.data).map(item => {
    if (item[0] !== '{' && item[0] !== undefined) {
      const res_data = item.split('"')[1];
      if (res_data) {
        item = decrypt_data(res_data);
      } else {
        item = decrypt_data(item);
      }
    } else {
      const final_data = item;
      item = JSON.parse(final_data);
    }
    return item;
  });
  return resFiles;
};

// By Abhishek on 30-6-25: for Project explorer
export let list_folders_res = '';

export const setList_folders_res = (val) => {
  list_folders_res = val;
};

export const getList_folders_res = () => {
  return list_folders_res;
};

// for  current file name
let curr_file_name = '';

export const set_curr_file_name = (val) => {
  curr_file_name = val;
};

export const get_curr_file_name = () => {
  return curr_file_name;
};

let allMyProjectsList;
export const get_all_my_projects_list = () => {
  return allMyProjectsList;
};
export const set_all_my_projects_list = (val) => {
  allMyProjectsList = val;
};
let my_project_api_flag = true;
export const set_checkAPI_My_Project = () => {
  my_project_api_flag = false;
};
export const get_checkAPI_My_Project = () => {
  return my_project_api_flag
};
export const getMyProjectAllData = async (getUserEmail, getUserType, page = 1, limit = 0, type = 'my_projects') => {
  set_checkAPI_My_Project();
  let dataMyProject = await getProjectWinflowsFileList(getUserEmail, getUserType, page, limit, type);
  dataMyProject = await getProjectWinflowsFileList(getUserEmail, getUserType, page, dataMyProject.data.filecount, type);
  const dec_data = decryptDataSharedAndMyProject(dataMyProject.data);
  const resultData = dec_data.map(item => {
    item.name = item.filename.split('.json')[0];
    return item;
  });
  set_all_my_projects_list(resultData);
  return resultData;
};
let allSharedProjectsList;
export const get_all_shared_projects_list = () => {
  return allSharedProjectsList;
};
export const set_all_shared_projects_list = (val) => {
  allSharedProjectsList = val;
};
let shared_project_api_flag = true;
export const set_checkAPI_shared_Project = () => {
  shared_project_api_flag = false;
};
export const get_checkAPI_shared_Project = () => {
  return shared_project_api_flag
};
export const getSharedProjectAllData = async (getUserEmail, getUserType, page = 1, limit = 0, type = 'shared_projects') => {
  set_checkAPI_shared_Project();
  let dataSharedProject = await getProjectWinflowsFileList(getUserEmail, getUserType, page, limit, type);
  const allCount = dataSharedProject.data.filecount;
  dataSharedProject = await getProjectWinflowsFileList(getUserEmail, getUserType, page, allCount, type);
  const dec_data = decryptDataSharedAndMyProject(dataSharedProject.data);
  const resultData = dec_data.map(item => {
    item.name = item.filename.split('-sharedFile.json')[0];
    item.name = item.name.split('.json')[0]; // inCase .json occur two times
    return item;
  });
  set_all_shared_projects_list(resultData);
  return resultData;
};
let language_selection = '';
export const set_language_selection = (language) => {
  language_selection = language;
};
export const get_language_selection = () => {
  return language_selection;
};

let dbTransactionData = '';
export const setDbTransactionData = (data) => {
  dbTransactionData = data;
}
export const getDbTransactionData = () => {
  return dbTransactionData;
}
let captuRadioButton = false;
export const setCaptuBoolean = (val) => {
  captuRadioButton = val;
}
export const getCaptuBoolean = () => {
  return captuRadioButton;
}